import { useEffect, useState } from "react";
import { API } from "@/lib/api";

export const useJobsFeed = (filters, pageSize = 6) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const key = JSON.stringify(filters);

  useEffect(() => {
    const filters = JSON.parse(key);
    const controller = new AbortController();
    setLoading(true);
    setError(false);
    const timer = setTimeout(async () => {
      try {
        const params = new URLSearchParams({ ...filters, page_size: pageSize });
        const response = await fetch(`${API}/jobs?${params}`, { signal: controller.signal });
        if (!response.ok) throw new Error("Jobs unavailable");
        const result = await response.json();
        if (!Array.isArray(result.jobs)) throw new Error("Invalid job feed");
        if (!controller.signal.aborted) setData(result);
      } catch (err) {
        if (!controller.signal.aborted) { setError(true); setData(null); }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    }, 250);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [key, attempt, pageSize]);

  return { data, loading, error, retry: () => setAttempt((value) => value + 1) };
};
